// extracted by mini-css-extract-plugin
module.exports = {"Page":"startPage_Page__3-Q-L","title":"startPage_title__3Fvhh","btn":"startPage_btn__3ZPhH"};